export default function DropdownButton() {
  const toggleButtons = document.querySelectorAll('.js-dropdown-button-toggle');
  const toggleActiveClass = 'js-dropdown-button-active';

  function handleClickOutside(event) {
    document.querySelectorAll('.js-dropdown-button-active').forEach((activeDropdown) => {
      if (!activeDropdown.closest('.dropdown-button').contains(event.target)) {
        activeDropdown.classList.remove(toggleActiveClass);
      }
    });
  }

  function closeAllDropdowns() {
    document.querySelectorAll('.js-dropdown-button-active').forEach((activeDropdown) => {
      activeDropdown.classList.remove(toggleActiveClass);
    });
  }

  function toggleDropdown(event, toggleButton) {
    const dropdown = toggleButton.closest('.dropdown-button');
    const dropdownContent = dropdown.querySelector('.dropdown-button__secondary-links');

    if (dropdownContent) {
      const isActive = dropdownContent.classList.contains(toggleActiveClass);
      closeAllDropdowns();
      if (!isActive) {
        dropdownContent.classList.add(toggleActiveClass);
      }
    }
  }

  toggleButtons.forEach((toggleButton) => {
    toggleButton.addEventListener('click', (event) => {
      event.stopPropagation();
      toggleDropdown(event, toggleButton);
    });

    toggleButton.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleDropdown(event, toggleButton);
      }
    });
  });

  document.addEventListener('click', handleClickOutside);
}
